import {useContext} from "react";
import {AuthContext} from "../../contexts/auth/authContext";

export default function useAuth() {
  return useContext(AuthContext);
}
